export default "__VITE_ASSET__BRJx2tcN__"